import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Container, CssBaseline, Typography, Box, Grid, Paper, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import MobileAppCard from './MobileAppCard';
import WebCard from './WebCard';
import IconButton from '@mui/material/IconButton';

import logo_camting from './image/camting.jpg';
import logo_sating from './image/sating.jpg';
import logo_gpt from './image/img.jpeg';
import logo_meethumb from './image/meethumb.jpeg';
import backgroundImage from './image/logo.jpeg';
import binbang from './image/binbang.jpg';
import similar from './image/sel.jpg';


const Home = () => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate('/meethumb'); // '/newpage' 경로로 이동
  };

  const similarClick = () => {
    navigate('/Celebrity'); // '/newpage' 경로로 이동
  };


  return (
    <Container component="main" maxWidth="false" maxHeight="false" sx={{backgroundColor:'#ffffff'}}>

      <CssBaseline />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center', // 수직 중앙 정렬
          justifyContent: 'center', // 수평 중앙 정렬
        }}
      >

      </Box>


      <Typography variant="h6" color="common.black" component="div" sx={{ mt: 4, display: 'flex', justifyContent: 'center'}} >
        {"deep-ring"}
      </Typography>

      <Typography variant="h6" color="common.black" component="div" sx={{ mt: 1, mb:2, display: 'flex', justifyContent: 'center'}} >
        {"We connect people with AI"}
      </Typography>

      <Typography variant="h8" color="grey.500" component="div" sx={{ mt: 4,display: 'flex', justifyContent: 'center'}} >
        {"email : deepring2025@gmail.com"}
      </Typography>
      <Typography variant="h8" color="grey.500" component="div" sx={{mb:2, display: 'flex', justifyContent: 'center'}} >
        {"instagram : @meethumb_"}
      </Typography>

      <Grid container spacing={5} sx={{ mt: 2 }}>
        <Grid item xs={12} md={4}>
          <MobileAppCard title="캠퍼스팅 - 대학생 소개팅" icon={logo_camting}
           playLink={'https://play.google.com/store/apps/details?id=jstudio.cting'}
           appSLink={'https://apps.apple.com/kr/app/id1272033233'}
           />
        </Grid>

          <Grid item xs={12} md={4}>
            <MobileAppCard title="직팅- 직장인 소개팅" icon={logo_sating}
              playLink={'https://play.google.com/store/apps/details?id=cl.jting'}
              appSLink={'https://apps.apple.com/kr/app/id1317589117'}
             />
          </Grid>


        <Grid item xs={12} md={4}>
          <MobileAppCard title="빈방 - 쉐어하우스, 원룸" icon={binbang}
            playLink={'https://play.google.com/store/apps/details?id=com.save_money.binbang'}
            appSLink={'https://apps.apple.com/kr/app/id1435609858'}
           />
        </Grid>

      </Grid>



      <Box sx={{ flexGrow: 1,mb:4}} />
    </Container>
  );
}




export default Home;
